import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faAddressCard, faTicket } from '@fortawesome/free-solid-svg-icons';
import { RouterLink } from '@angular/router';
import { DrawState, ProfileDrawProjection } from '@unicup-ticketing/service';
import { ButtonComponent } from '@unicup-ticketing/ui';
import { DrawItemContainerComponent } from '@unicup-ticketing/core';

@Component({
  selector: 'pos-draw-item',
  imports: [FaIconComponent, RouterLink, ButtonComponent, DrawItemContainerComponent],
  templateUrl: './staff-draw-item.component.html',
  styleUrl: './staff-draw-item.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StaffDrawItemComponent {
  draw = input.required<ProfileDrawProjection>();
  protected readonly DrawState = DrawState;
  protected readonly faAddressCard = faAddressCard;
  protected readonly faTicket = faTicket;
}
